var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/_core.js
// module id = 322
// module chunks = 0